// ABOUTME: Builds a Netscape bookmarks.html file from dashboard links.
// ABOUTME: Shared by Settings (signed in) and the guest banner, so guests can take their links along.

import type { DashboardItem } from "../services/dashboardService";

// Escape before interpolating — a title containing " or < used to produce a
// corrupt bookmarks file that browsers would refuse to re-import.
function esc(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/** The standard bookmarks export format every browser imports. Links only; widgets have no URL. */
export function buildBookmarksHtml(items: DashboardItem[]): string {
  const links = items.filter((item) => item.type === "link" && !item.isAd && item.url);
  let html =
    '<!DOCTYPE NETSCAPE-Bookmark-file-1><META HTTP-EQUIV="Content-Type" CONTENT="text/html; charset=UTF-8"><TITLE>Bookmarks</TITLE><H1>Bookmarks</H1><DL><p>';
  for (const link of links) {
    const addDate = link.createdDate ? Math.floor(link.createdDate / 1000) : "";
    html += `<DT><A HREF="${esc(link.url ?? "")}" ADD_DATE="${addDate}">${esc(link.name || link.url || "")}</A></DT>`;
  }
  html += "</DL><p>";
  return html;
}

/** How many items an export would contain, for enabling the button. */
export function exportableLinkCount(items: DashboardItem[]): number {
  return items.filter((item) => item.type === "link" && !item.isAd && item.url).length;
}

/** Triggers a browser download of the bookmarks file. Browser-only. */
export function downloadBookmarksFile(
  items: DashboardItem[],
  filename = "start-bookmarks.html"
): void {
  const blob = new Blob([buildBookmarksHtml(items)], { type: "text/html" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
